$(document).ready(function () {
  // Menu mobile
  if (window.matchMedia("(max-width: 991px)").matches) {
    $(".js-toggleMenu").on("click", function (e) {
      e.preventDefault();
      $("header").toggleClass("is-expanded");

      if (!$("body").hasClass("nav-expanded")) {
        setTimeout(function () {
          $("body").addClass("nav-expanded");
        }, 300);
      } else {
        $("body").removeClass("nav-expanded");
      }
    });
    //sottomenu
    $(".has-submenu> a").on("click", function (e) {
      e.preventDefault();

      var selectedItem = $(this).parent(".has-submenu");
      $(this).siblings(".submenu").slideToggle();

      if (!$(selectedItem).hasClass("is-selected")) {
        $(".has-submenu")
          .children(".submenu")
          .addClass("is-open");
        selectedItem
          .addClass("is-selected").children("a").attr("aria-expanded", "true");
         
      } else {
        $(".has-submenu")
        .children(".submenu")
          .removeClass("is-open");
        selectedItem
          .removeClass("is-selected")
          .children("a").attr("aria-expanded", "false"); 
      }
    });
    //sottomenu II livello divisioni
    $('.submenuDivision >a').on('click',function(e){
      e.preventDefault();
      $(this).siblings('div').slideToggle();
  });
  }

  // Menu desktop
  if (window.matchMedia("(min-width: 992px)").matches) {
    $(".has-submenu > a").on("click", function (event) {
      event.preventDefault();

      var selectedItem = $(this).parent(".has-submenu");
 if (!$(selectedItem).hasClass("is-selected")) {
        $(".has-submenu")
          .removeClass("is-selected")
          .children(".submenu")
          .removeClass("is-open");
        selectedItem
          .addClass("is-selected")
          .children(".submenu")
          .addClass("is-open")
        $("header").addClass("nav-isOpen");
      } else {
        selectedItem
          .removeClass("is-selected")
          .children(".submenu")
          .removeClass("is-open")
          $("header").removeClass("nav-isOpen");
      } 

      if($(this).attr('aria-expanded') == 'true'){    
        $(this).attr('aria-expanded','false').parents().siblings('.has-submenu').children('a').attr('aria-expanded','false');
      }

      else if($(this).attr('aria-expanded') == 'false'){
        $(this).attr('aria-expanded','true').parents().siblings('.has-submenu').children('a').attr('aria-expanded','false');
      }     

    });

    //sottomenu II livello divisioni
   /*  $('.submenuDivision> li:first-child').addClass("active");

    $('.submenuDivision> li >a').on('click',function(e){
      e.preventDefault();
      $('.submenuDivision> li').removeClass("active");
      $(this).parents('li').addClass("active");
  }); */

    $(document).click(function (e) {
      //check if the clicked area is dropDown or not
      if ($(".has-submenu").has(e.target).length === 0) {
        $(".has-submenu")
          .removeClass("is-selected")
          .children(".submenu")
          .removeClass("is-open");
        $("header").removeClass("nav-isOpen");
      }
    });
       // Lingue
       $('.js-dropdown').children('button').on('click', function(event){
        event.preventDefault();
        $(this).next('ul').toggle();
    });

    $(document).keyup(function (e) {
      if (e.keyCode == 27) {
        // escape key maps to keycode `27`
        $(".has-submenu")
          .removeClass("is-selected")
          .children(".submenu")
          .removeClass("is-open")
          .siblings("a").attr("aria-expanded", "false");
      }
    });


    $(document).click(function (e) {
      //check if the clicked area is dropDown or not
        if ($('.has-submenu').has(e.target).length === 0) {
              $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
          }
        
        if ($('.js-dropdown,.js-dropdown > ul').has(e.target).length === 0) {
              $('.js-dropdown > ul').hide();
          }
         
      })
  }
 


  if ($('.mastheadVideo').length > 0 && $('#mastVideo').length > 0 && $('#mastVideoPlay').length > 0) {
  const mastVideo = document.getElementById('mastVideo');
  const mastVideoPlay = document.getElementById('mastVideoPlay');
  const mastVideoSection = document.querySelector('.masthead');
  mastVideoPlay.addEventListener("click", () => {
      mastVideo.play();
      mastVideoSection.classList.add('is-playing');
  });
  mastVideo.addEventListener('ended', () => {
      mastVideo.load();
      mastVideoSection.classList.remove('is-playing');
  }, false);
}

 /*
 $('input[type="radio"][name="tipocliente"]').click(function() {
  if($('#infoprod_tipocliente_azienda').is(':checked')) { 
    $('.company-info').slideDown();
  }

  else if($('#infoprod_tipocliente_privato').is(':checked')) { 
    $('.company-info').slideUp();
  }
  */


  // Modale per lancio landing

  const modal = document.getElementById('autoModal');
  // Solo se esiste faccio il resto
  if (modal) {
      const modalCloseBtn = document.getElementById("closeBtn");
      const modalOpenBtn = document.getElementById("openModalBtn");

      // Iubenda che comanda l'apertura del popup
      window._iub = window._iub || [];
      window._iub.csConfiguration = window._iub.csConfiguration || {};
      window._iub.csConfiguration.callback = {
        // Sarebbe per quando l'utente chiude il banner Iubenda ma non va, al suo posto uso l'observer sotto
        /*
        onBannerClosed: function () {
          console.log("BANNER CLOSED");
          showModalAfterIubenda();
        },
        */
        // Per i caricamenti del sito DOPO aver chiuso il banner Iubenda
        onConsentRead: function () {
          //console.log("CONSENT READ");
          showModalAfterIubenda();
        },
        /*
        onReady: function () {
          console.log("CONSENT READY");
        },
        onConsentFirstGiven: function () {
          console.log("CONSENT FIRST GIVEN");
        },
        onConsentGiven: function () {
          console.log("CONSENT GIVEN");
        }
        */
      };

      // Workaround per catturare la chiusura del banner Iubenda
      (function () {
        let bannerWasVisible = false;
      
        function isBannerVisible() {
          const el = document.querySelector('.iubenda-cs-container');
          return !!(el && el.offsetParent !== null);
        }
      
        const observer = new MutationObserver(() => {
          const visible = isBannerVisible();
      
          // Il banner appare
          if (visible && !bannerWasVisible) {
            //console.log('Banner shown');
            bannerWasVisible = true;
          }
      
          // Il banner scompare (chiusura reale)
          if (!visible && bannerWasVisible) {
            //console.log('BANNER CLOSED');
            bannerWasVisible = false;
            showModalAfterIubenda();
          }
        });
      
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true
        });
      })();

      // Apertura in dev (senza Iubenda)
      if (typeof(window._fakeIub) !== "undefined") {
        showModalAfterIubenda();
      }

      // Apertura automatica (2 sec + LocalStorage)
      /*
      if (!localStorage.getItem('modalGiaVista')) {
        setTimeout(() => {
          modal.showModal();
          localStorage.setItem('modalGiaVista', 'true');
        }, 500);
      }
      */

      // Apertura popup grande comandata da Iubenda (appena chiudo il banner o se l'ho chiuso al caricamento precedente)
      function showModalAfterIubenda() {
          // Popup grande
          if (!localStorage.getItem('modalGiaVista')) {
            setTimeout(() => {
              modal.showModal();
              localStorage.setItem('modalGiaVista', 'true');
            }, 500);
          }
      }

      // Popup ridotto
      // Nota: se ho settato modalGiaVista significa che ho visto il popup grande, quindi ho anche gia' chiuso il banner Iubenda
      if (localStorage.getItem('modalGiaVista')) {
        modalOpenBtn.style.display = "block";
        //modalOpenBtn.classList.add("animate-pop");
      }

      //  Chiusura con ESC
      modal.addEventListener('cancel', (e) => {
        e.preventDefault(); 
        modal.close();
        modalOpenBtn.style.display = "block";
        modalOpenBtn.classList.add("animate-pop");
      });

      //  Chiusura cliccando all'esterno della modale
      modal.addEventListener('click', (e) => {
        // Se il target del click è proprio l'elemento <dialog> 
        // e non i suoi figli, significa che l'utente ha cliccato sullo sfondo
        if (e.target === modal) {
          modal.close();
          modalOpenBtn.style.display = "block";
          modalOpenBtn.classList.add("animate-pop");
        }
      });

      //  Chiusura con bottone
      modalCloseBtn.onclick = function() {
        modal.close();
        modalOpenBtn.style.display = "block";
        modalOpenBtn.classList.add("animate-pop");
      }

      // Riapertura modale
      modalOpenBtn.onclick = function() {
        modal.showModal();
        modalOpenBtn.classList.remove("animate-pop");
      }
  }
  
}); 



//navbar intersection observer
if (document.querySelector(".mastheadVideo")) {
  const header = document.querySelector("header");
  //const sectionOne = document.querySelector(".mastheadVideo");
  const sectionOne = document.querySelector(".mastheadTxt");

  const sectionOneOptions = {
    // rootMargin: "-650px 0px 0px 0px",
    rootMargin: "-300px 0px 0px 0px"
  };

  const sectionOneObserver = new IntersectionObserver(function (
    entries,
    sectionOneObserver
  ) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        header.classList.add("nav-scrolled");
      } else {
        header.classList.remove("nav-scrolled");
      }
    });
  },
  sectionOneOptions);

  sectionOneObserver.observe(sectionOne);
} else {
  const header = document.querySelector("header");
  header.classList.add("backGblack");
}

//Back to Section Sector intersection observer
if ($('.btsSections').length > 0) {
var targetBts = document.querySelector(".btsSections");
var scrollToTopBtn = document.querySelector(".backToSectors");
var rootElement = document.documentElement;

const targetBtsOptions = {
  rootMargin: "-70% 0px -30% 0px",
};

function callback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      scrollToTopBtn.classList.add("enabled");
    } else {
      scrollToTopBtn.classList.remove("enabled");
    }
  });
}

let observer = new IntersectionObserver(callback,targetBtsOptions);
observer.observe(targetBts);
}


//Number animation intersection observer
if ($('.tanCircles').length > 0) {
  var targetNumbers = document.querySelector(".circleNumbers");
  //var scrollToTopBtn = document.querySelector(".backToSectors");
  var rootElement = document.documentElement;
  
  const targetNumbersOptions = {
    rootMargin: "-70% 0px -30% 0px",
  };
  
  function callback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        
let valueDisplays = document.querySelectorAll(".num");
let interval = 100;
valueDisplays.forEach((valueDisplay) => {
  let startValue = 0;
  let endValue = parseInt(valueDisplay.getAttribute("data-val"));
  let duration = Math.floor(interval / endValue);
  let counter = setInterval(function () {
    startValue += 10;
    valueDisplay.textContent = startValue;
    if (startValue == endValue) {
      clearInterval(counter);
    }
  }, duration);
});

let valueFastDisplays = document.querySelectorAll(".numFast");
valueFastDisplays.forEach((valueDisplay) => {
  let startValue = 0;
  let endValue = parseInt(valueDisplay.getAttribute("data-val"));
  let duration = Math.floor(interval / endValue);
  let counter = setInterval(function () {
    startValue += 50;
    valueDisplay.textContent = startValue;
    if (startValue == endValue) {
      clearInterval(counter);
    }
  }, duration);
});
      }
    });
  }
  
  let observer = new IntersectionObserver(callback,targetNumbersOptions);
  observer.observe(targetNumbers);
  }

 



///////////

//division circles

/* const divCircles = document.querySelectorAll(".divisionCircle");

divCircles.forEach((divCircle, i) => {
  divCircle.addEventListener("mouseenter", () => {
    divCircle.classList.add("hover");
    divCircles.forEach((circle, j) => {
      i != j && circle.classList.remove("hover");
    });
  });
}); */
///////////

// video  YT embedded

/* let player;

function setupYT() {
  player = new YT.Player(
    document.querySelector("#jsapi").shadowRoot.querySelector("iframe"),
    {
      events: {
        onReady: onPlayerReady,
      },
    }
  );
}

function onPlayerReady() {}

document.addEventListener(
  "liteYoutubeIframeLoaded",
  () => {
    try {
      setupYT();
      console.log("okkk");
    } catch (e) {
      setTimeout(setupYT, 100);
    }
  },
  false
);

document.querySelector(".playEmb").addEventListener("click", () => {
  document.querySelector("lite-youtube").style.zIndex = "1";
  player.playVideo();
}); */

/* function slickify() {
  $(".newsFlex").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    prevArrow: null,
    lazyLoad: "ondemand",
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 481,
        settings: "unslick",
      },
    ],
  });
}

$(window).resize(function () {
  var $windowWidth = $(window).width();
  if ($windowWidth < 481) {
    slickify();
  }
}); */

/* function slickify() {
  $(".newsFlex")
    .not(".slick-initialized")
    .slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      centerMode: true,
      prevArrow: null,
      lazyLoad: "ondemand",
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 480,
          settings: "unslick",
        },
      ],
    });
}  */

/* if (window.matchMedia("(max-width: 480px)").matches){
  $(".newsFlex").slick({
    infinite: false,
    slidesToShow: 1,
    //slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '50px',
    //swipeToSlide: true
    //prevArrow: null,
    //lazyLoad: "ondemand"
  });
} */



 /* $('.slider').slick({
  arrows: true,
  dots: true,
  infinite: false,
  slidesToShow: 1,
  //slidesToScroll: 1,
  //swipeToSlide: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: false,
        centerMode: true,
        centerPadding: '50px'
      }
  },
  ],
}); */

/*   $('.slider').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    });  */


    // Swiper slider
    const swiper = new Swiper('.swiper', {
      slidesPerView: 1.5,
      spaceBetween: 20,
      centeredSlides: true,
      speed: 200,
      //slideRole: 'link',

      breakpoints: {
        // when window width is >= 481px
        481: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        
        },
      }
    });


if (window.matchMedia("(max-width: 480px)").matches){
  swiperOnlyMobile = new Swiper ('.newsFlex', {
    slidesPerView: 1.5,
    spaceBetween: 20,
    speed: 200,
    centeredSlides: true,
    slideRole: null
   });
}

 // Accordion faq


 $('.accordion .js-content').hide();
 $('.accordion .js-header').click(function () {
     $(this).next('.js-content').slideToggle();
     $(this).toggleClass('active');

      // toggle attributi
      if($(this).children('button').attr('aria-expanded') == 'true'){
         $(this).children('button').attr('aria-expanded','false');
     }

     else if($(this).children('button').attr('aria-expanded') == 'false'){
         $(this).children('button').attr('aria-expanded','true').siblings().attr('aria-expanded','false');
     }

     return false;
 });

 var $item = $('.accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header



 $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina


     var keyCode = e.keyCode || e.which;


     if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar


         $(this).children().next().slideToggle();
         $(this).siblings().children().next().slideUp();
         $(this).children().toggleClass('active');

         $(this).siblings().children().removeClass('active');


         if($(this).children().children('button').attr('aria-expanded') == 'true'){
             $(this).children().children('button').attr('aria-expanded','false');
         }

         else if($(this).children().children('button').attr('aria-expanded') == 'false'){
             $(this).children().children('button').attr('aria-expanded','true').siblings().attr('aria-expanded','false');
         }

         return false;
     }



 });
/*     
// Store the window width
var windowWidth = $(window).width();

//Resize Event
 $(window).resize(function(){
    // Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
    if ($(window).width() != windowWidth) {

        // Update the window width for next time
        windowWidth = $(window).width();

        setTimeout(function(){
            window.location.reload();
        });

    }
}
);  */

/* $(window).resize(function () {
  var $windowWidth = $(window).width();
  if ($windowWidth < 481) {
    //console.log($windowWidth);
    slickify();
  }
}); */



/* const videoBg = document.getElementById("videoBg").src;
document.querySelector("lite-youtube").style.backgroundImage =
  "url('" + videoBg + "')";
console.log("a" + document.querySelector("lite-youtube").style); */

